import React from 'react';
import { Link } from 'react-router-dom';
import homeBanner from '../assets/images/home-banner.jpg';
import service1 from '../assets/images/service1.png';
import service2 from '../assets/images/service2.png';
import toolsImage from '../assets/images/ai-tools.jpg';

const Home = () => {
  return (
    <div style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}>
      {/* Welcome Banner */}
      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
        <img src={homeBanner} alt="Welcome Banner" style={{ width: '100%', height: 'auto' }} />
      </div>

      {/* About Us Section */}
      <section style={{ padding: '50px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '36px', color: '#22225f' }}>About Us</h2>
        <p style={{ lineHeight: '1.8', maxWidth: '800px', margin: '20px auto' }}>
          At <strong>CALFIN Technologies Private Limited</strong>, we aim to transform the way businesses and individuals
          access financial resources. With our expert guidance, we simplify the process of obtaining business loans,
          managing credit, and leveraging government-backed financial schemes to meet your goals.
        </p>
        <p style={{ lineHeight: '1.8', maxWidth: '800px', margin: '20px auto' }}>
          Our mission is to empower businesses to thrive in a competitive landscape by offering personalized solutions and
          cutting-edge tools. Partnering with CALFIN means gaining access to innovative financial solutions tailored to
          your needs.
        </p>
        <Link to="/about">
          <button
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#0073e6',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              fontSize: '16px',
            }}
          >
            Learn More
          </button>
        </Link>
      </section>

      {/* Our Services Section */}
      <section style={{ padding: '50px', textAlign: 'center', backgroundColor: '#f9f9f9' }}>
        <h2 style={{ fontSize: '36px', color: '#22225f' }}>Our Services</h2>
        <p style={{ lineHeight: '1.8', maxWidth: '800px', margin: '0 auto' }}>
          We offer a comprehensive range of services to cater to the financial needs of businesses and individuals. From
          securing flexible business loans to accessing pre-approved overdraft facilities and government-backed schemes, we
          provide end-to-end support.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap', marginTop: '30px' }}>
          <div style={{ width: '300px', textAlign: 'center' }}>
            <img src={service1} alt="Business Loans" style={{ width: '100%', borderRadius: '10px' }} />
            <h3 style={{ fontSize: '20px', color: '#22225f', margin: '10px 0' }}>Business Loans</h3>
            <p>Unlock funding to fuel your business expansion and operations.</p>
          </div>
          <div style={{ width: '300px', textAlign: 'center' }}>
            <img src={service2} alt="Overdraft Facilities" style={{ width: '100%', borderRadius: '10px' }} />
            <h3 style={{ fontSize: '20px', color: '#22225f', margin: '10px 0' }}>Overdraft Facilities</h3>
            <p>Flexible credit options to manage your cash flow effectively.</p>
          </div>
        </div>
        <Link to="/services">
          <button
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#0073e6',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              fontSize: '16px',
            }}
          >
            Explore All Services
          </button>
        </Link>
      </section>

      {/* AI Financial Tools Section */}
      <section style={{ padding: '50px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '36px', color: '#22225f' }}>AI Financial Tools</h2>
        <img
          src={toolsImage}
          alt="AI Tools"
          style={{ width: '100%', height: 'auto', borderRadius: '10px', marginBottom: '20px' }}
        />
        <p style={{ lineHeight: '1.8', maxWidth: '800px', margin: '0 auto' }}>
          Our AI-powered tools enable smarter decision-making by providing accurate insights. From EMI calculators to
          savings goal trackers, our tools are designed to simplify your financial journey and help you achieve your
          objectives.
        </p>
        <Link to="/tools">
          <button
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#0073e6',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              fontSize: '16px',
            }}
          >
            Explore Tools
          </button>
        </Link>
      </section>

      {/* Blog Section */}
      <section style={{ padding: '50px', textAlign: 'center', backgroundColor: '#f9f9f9' }}>
        <h2 style={{ fontSize: '36px', color: '#22225f' }}>Blog</h2>
        <p style={{ lineHeight: '1.8', maxWidth: '800px', margin: '0 auto' }}>
          Gain valuable insights from our expert-curated blog posts. Explore topics ranging from financial planning to
          business growth strategies and stay informed about the latest trends in the financial world.
        </p>
        <Link to="/blog">
          <button
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#0073e6',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              fontSize: '16px',
            }}
          >
            Read More
          </button>
        </Link>
      </section>

      {/* Contact Us Section */}
      <section style={{ padding: '50px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '36px', color: '#22225f' }}>Contact Us</h2>
        <p style={{ lineHeight: '1.8', maxWidth: '800px', margin: '0 auto' }}>
          Have questions or need assistance? Our team is here to provide expert advice and personalized support for all your
          financial needs. Reach out to us today and let's achieve your financial goals together.
        </p>
        <Link to="/contact">
          <button
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#0073e6',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              fontSize: '16px',
            }}
          >
            Get in Touch
          </button>
        </Link>
      </section>

      {/* Floating WhatsApp Chat Button */}
      <a
        href="https://wa.me/917569523497?text=Hello!%20I%20would%20like%20to%20know%20more%20about%20your%20services."
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          width: '60px',
          height: '60px',
          backgroundColor: '#25d366',
          borderRadius: '50%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          style={{ width: '40px', height: '40px' }}
        />
      </a>
    </div>
  );
};

export default Home;
